import { useContext } from 'react';
import { NotificationType } from 'common/enums';
import { appActions, AppContext } from 'context';
import {
  VaultDetailContext,
  vaultDetailActions,
} from 'context/vault-detail-context';
import { NotificationObject } from 'models/notificationObject';
import { VaultsController } from 'networking/controllers/vaults-controller';

// Creates a new (empty) album in the current vault and opens it in the album
// detail modal. Shared by the top-bar "New +" button and the dashboard
// "New Album" card.
export const useCreateAlbum = () => {
  const { dispatch } = useContext(AppContext);
  const {
    state: { vaultId },
    dispatch: dispatchVaultDetail,
  } = useContext(VaultDetailContext);

  // Returns the created album (or null on failure) so callers can navigate to
  // it or open it in a specific flow. Pass `overrideVaultId` on screens where
  // the VaultDetailContext vaultId isn't populated (e.g. the view-mode top bar),
  // and `name` to create the album with a user-provided title.
  return async (overrideVaultId?: number, name?: string) => {
    try {
      const album = await VaultsController.createAlbum(
        overrideVaultId ?? vaultId,
        name,
      );
      dispatchVaultDetail({
        type: vaultDetailActions.ADD_TO_UNANSWERED,
        album,
      });
      dispatchVaultDetail({
        type: vaultDetailActions.SET_ACTIVE_ALBUM,
        activeAlbumPointer: { id: album.id, listType: 'unanswered' },
      });
      return album;
    } catch (e) {
      dispatch({
        type: appActions.NOTIFICATION,
        notification: new NotificationObject({
          show: true,
          title: 'There was an error creating the album',
          message: 'Please try again',
          type: NotificationType.Error,
        }),
      });
      return null;
    }
  };
};
